import { ExtraItemPayload } from '@features/backOffice/orders/update/components/purchaseMenus/type';
import { DeliveryType } from '@models/ropolo';
import { v4 as uuidV4 } from 'uuid';
import { UpdateOrderState } from '../type';

const addExtraItemToMenu = (state: UpdateOrderState, addItem: ExtraItemPayload): UpdateOrderState => {
  const temp = addItem?.selectedToppings?.map((z) => z.id);
  const existMenu = state.updatedOrder?.orderItems?.filter((x) => x.menuItemId === addItem?.menuItem?.id);
  const exist = existMenu?.some((x) => {
    const check =
      temp?.length === x?.toppings?.length && temp?.every((y) => x?.toppings?.map((z) => z.toppingId).includes(y));
    return check;
  });
  if (exist) {
    return {
      ...state,
      updatedOrder: {
        ...state.updatedOrder,
        orderItems: state.updatedOrder?.orderItems?.map((item) => {
          if (
            item.menuItemId === addItem?.menuItem.id &&
            temp.length === item?.toppings?.length &&
            temp.every((y) => item?.toppings?.map((z) => z.toppingId).includes(y))
          ) {
            return {
              ...item,
              count: (item?.count || 0) + 1,
              orderItemToppings: item?.toppings?.map((x) => ({
                ...x,
                count: (item.count || 0) + 1,
              })),
            };
          }
          return item;
        }),
      },
    };
  }

  return {
    ...state,
    updatedOrder: {
      ...state.updatedOrder,
      orderItems: [
        ...(state.updatedOrder?.orderItems || []),
        {
          count: 1,
          discount: addItem?.menuItem?.discount,
          id: uuidV4(),
          menuItemId: addItem?.menuItem?.id,
          menuItemTitle: addItem?.menuItem?.title,
          packagingCost:
            state.updatedOrder?.deliveryType === DeliveryType.SERVE
              ? addItem?.menuItem?.servePackagingCost
              : addItem?.menuItem?.packagingCost,
          price: addItem?.menuItem?.price,
          title: addItem?.menuItem?.title,
          toppings:
            addItem?.selectedToppings?.map((x) => ({
              count: 1,
              id: x.id,
              toppingId: x.id,
              price: x.price,
              title: x.title,
            })) || [],
        },
      ],
    },
  };
};

export default addExtraItemToMenu;
